module.exports = __webpack_public_path__ + "img/icon_serve@2x.c90afe97.png";